<template>
  <div class="animated fadeIn list-of-cashflow">
    <b-card>
      <div slot="header">RECOCILE BANK STATEMENT 
        <div class="card-header-actions">
          <button  class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
          <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Print
          </button>
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="7">
                <b-row>
                    <b-col lg="7">
                        <b-input-group >
                            <b-input-group-prepend><label>Cash/bank Account</label></b-input-group-prepend>
                            <b-form-input readonly v-model="filter.namabank" @keyup.13.native="lkuBankaccountShow=true" :state="!$v.filter.kodebank.$error"></b-form-input>
                            <b-input-group-append>
                                <b-btn text="Button" @click="lkuBankaccountShow=true">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                            </b-input-group-append>
                            <b-input-group-append>
                                <span class="input-group-text" style="width:70px;">{{filter.matauang}}</span>
                            </b-input-group-append>
                        </b-input-group>

                    </b-col>   
                    <b-col lg="5" >                            
                            <b-input-group >
                                <b-input-group-prepend class="d-md-inline d-lg-none"><label>Account No.</label></b-input-group-prepend>
                                <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Account#</span></b-input-group-prepend>
                                <b-form-input disabled v-model="filter.nomorrek"></b-form-input>
                            </b-input-group>
                    </b-col>
                </b-row>                      
        </b-col>
        <b-col lg="5">
            <b-input-group >
                <b-input-group-prepend><span  class="pt-2 mr-2">Trx. Date Range</span></b-input-group-prepend>
                <b-form-input v-model="filter.tgl1" type="date" placeholder="from date"></b-form-input>
                <b-form-input v-model="filter.tgl2" type="date" placeholder="until date" class="ml-1"></b-form-input>
                <b-input-group-append ><b-button class="ml-2 btn btn-success mr-2" @click="getData()" > <i class="fa fa-play"></i> Process</b-button></b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <div class="report-wraper">
          <table style="width: 100%;">
              <thead>
                  <tr>
                  <th width="100px">Trx. Date</th>
                  <th width="110px">Trx. Number</th>
                  <th >Description</th>
                  <th >Pay To/receipt fr</th>
                  <th >Payment Method</th>
                  <th width="90px">Create By</th>
                  <th style="text-align:right" width="150px">Debit</th>
                  <th style="text-align:right" width="150px">Credit</th>
                  <th style="text-align:center" width="40px">Reconcile</th>
                  <th style="text-align:center" width="100px">Reconcile By</th>
                  <th style="text-align:center" width="20px"><a href="#" data-toggle="tooltip" title="Double Clik to Reconcile !">Edited</a></th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="row in rptLines" :key="row.nilaiKey" @click.stop="confirmAction(row)" :class="{selected: row.selected === 1}">
                  <td><span v-if="row.tanggal"> {{row.tanggal | moment("DD MMM YYYY")}}</span></td>
                  <td><b-link @click.stop="printJv(row)"> {{row.nomor}}</b-link></td>
                  <td>{{row.uraian}}</td>
                  <td>{{row.terimadari}}</td>
                  <td>{{row.paymethod}}</td>
                  <td>{{row.createby}}</td>
                  <td style="text-align:right">{{row.valas_in | numFormat}}</td>
                  <td style="text-align:right">{{row.valas_out | numFormat}}</td>
                  <td v-if="(row.rekonsil==1)" style="text-align:center" >YES</td>
                  <td v-else></td>
                  <td>{{row.rekonby}}</td>                     
                  <td v-if="(row.edited==1)" class="edited" ><i class="fa fa-pencil"></i></td>
                  <td v-else></td>
                  </tr>
              </tbody>
          </table>
      </div>
    </b-card>

    <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
        <lku-bankaccount @click="onSelectLkuBankaccount" :isbank="bankOnly" :key="bankOnly" :formdata="lkuBankaccountData"></lku-bankaccount>
    </b-modal>        
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            tr.selected {
              background:#a0e2f7;
            }
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.edited {
              background: #f7cac9;
              text-align: center; 
            }

            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }
            tbody tr:hover {
                background-color: rgba(0, 0, 0, 0.05) !important;
                cursor: default;
            }
        }
    }
 
</style>

<script>
import moment from 'moment';
import bankrekon from "../../apis/bankrekon";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        kodebank: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
    lkuBankaccountData:{},  
      lkuBankaccountShow: false,
      bankOnly:1,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      filter: {kodebank:'',
        tgl1:this.$store.state.user.tglaktif,
        tgl2:moment().format('YYYY-MM-DD'),
      },
      username: this.$store.state.user.username,
      model:{},
      bankCashAcc: [],
      rptLines : []
    };
  },
  components: { Loading,lkuBankaccount},
  computed: {
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
  },  
  methods: {
    onSelectLkuBankaccount(lkuData) {
        this.lkuBankaccountData=lkuData;
        this.lkuBankaccountShow=false;
        this.filter.kodebank=lkuData.selected.kode;
        this.filter.matauang=lkuData.selected.matauang;
        this.filter.namabank=lkuData.selected.namabank;
        this.filter.nomorrek=lkuData.selected.nomorrek;
        this.lkuBankaccountShow=false;
    },
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
        this.rptLines = await bankrekon.get(this.filter);      
        this.isLoading=false;      
       }
    },
    confirmAction: function(data) {
        if (this.model.nilaiKey === data.nilaiKey) {
            this.model.selected = 1;
            this.model.rekonsil = (this.model.rekonsil) ? 0:1;
            this.model.rekonby = (this.model.rekonsil) ? this.username:'';
            this.model.edited = 1;
        } else {
            if (this.model) this.model.selected = 0;
            this.model=data;
            this.model.selected = 1;
            this.$forceUpdate();
        }
    },
    save: async function(ctx) {
        try {
            this.isLoading=true;
            const lines = this.rptLines.reduce((newArr, item) => {
                if (item.edited) {
                    newArr.push({rekonsil: item.rekonsil, 
                    rekonby: item.rekonby, namaKey: item.namaKey,
                    nilaiKey: item.nilaiKey,namatable: item.namatable });
                }
                return newArr;
            }, []);
            if (lines.length==0) {
                toastr.error('No Changes to be saved.');
                this.isLoading=false;      
            } else {
                this.rptLines = await bankrekon.save({lines});    
                this.isLoading=false;      
                this.getData();  
            }
        } catch (error) {
            this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                   
        }
    },
    printJv: async function(data){
        this.showConfirmAction=false;
        this.showList=false;
       if ((data.nomor !== 'BEGINING') && (data.nomor !== '')) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await bankrekon.printjv(data);
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } 
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                this.showReport=true;
                this.reportUrl= await bankrekon.print(this.filter);
                this.isLoading=false;
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await bankrekon.export(this.filter);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("/treasury/home");
    }
  }
};
</script>
